module.exports = __webpack_public_path__ + "static/about-img-06e0aabe354fd0dd9a129de35bd4d922.jpg";